import originJsonp from 'jsonp'
import axios from 'axios'
import qs from 'qs'
import { ElMessage as message } from 'element-plus'
import { getCookie, delCookie, setThumbnailSuffix } from './utils'
axios.defaults.withCredentials = true

axios.defaults.headers = {
    'Content-Type': 'application/json;charset=UTF-8'
}

let headerToken = 'X-Access-Token'
//POST传参序列化
axios.interceptors.request.use(
    config => {
        if (config.method === 'post') {
            config.data = qs.stringify(config.data)
        }
        if (config.custom) {
            config.headers = {
                'Content-Type': config.custom.headers['Content-Type']
            }
        }
        // else {
        //     config.headers = {
        //         "Content-Type": "application/x-www-form-urlencoded"
        //     };
        // }
        if (config.headers['Content-Type'] === 'application/json') {
            config.data = qs.parse(config.data)
        }
        
        if (getCookie(headerToken)) {
            // console.log(config.url.indexOf('getUserIdentity') > 0);
            // if (config.url.indexOf('getUserIdentity') == -1 || config.url.indexOf('aidMenuAuth') == -1) {
            //     config.headers[headerToken] = getCookie(headerToken)
            // }
            if (config.url.indexOf('getUserIdentity') > -1 || config.url.indexOf('aidMenuAuth') > -1) {
                
            } else {
                config.headers[headerToken] = getCookie(headerToken)
            }
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

//返回状态判断
axios.interceptors.response.use(
    res => {
        // debugger
        // console.log(res);
        if (res.data.code == 403 || res.data.code == 302 || res.data.code == 10002) {
            // console.log('123');
            delCookie('X-Access-Token')
            window.location.href = `/login.html`
            message.error('登录过期，请重新登录')
            return
        }
        if (res.data.code !== 200) {
            return Promise.reject(res)
        }

        if (res.data.status == '-99') {
            message.warn(res.data.message)
        }

        return res
    },
    error => {
        console.log(error)
        console.log(error.response)
        // let url = decodeURIComponent(window.location.href)
        // if (error.response.config.url.includes('/user/info')) {
        //     console.log('login');
        //     window.location.href = `/login.html`
        //     return
        // }
        return Promise.reject(error)
    }
)
export function getFetch(url, params = {}) {
    return axios.get(url, { params }).then(
        res => {
            // console.log("+============================",{res});
            if (res.status == 200 || res.data.code == 200) {
                return Promise.resolve(res.data.rt || res.data.data )
            }
            return Promise.reject(res.data)
        },
        error => {
            // console.log("+-----------------------",error);
            if (error.config.url.indexOf('getUserIdentity') > 0 || error.config.url.indexOf('aidMenuAuth') > 0 && error.status == 200) {
                return Promise.resolve(error.data.rt )
            }
            message.error(error.data.msg || error.data.message)
            // message.error('网络错误，请稍后重试');
            return Promise.reject(error)
        }
    )
}
export function postFetch(...args) {
    return axios.post(...args).then(
        res => {
            if (res.data.code == 200 || res.status == 200) {
                return Promise.resolve(res.data.rt || res.data.data)
            }
            return Promise.reject(res.data)
        },
        error => {
            message.error(error.data.message)
            // message.error('网络错误，请稍后重试');
            return Promise.reject(error)
        }
    )
}
export function jsonp(url, params = {}, option) {
    return new Promise((resolve, reject) => {
        let finalUrl = url + (url.indexOf('?') < 0 ? '?' : '&') + qs.stringify(params)
        originJsonp(finalUrl, { param: 'callback', ...option }, (err, data) => {
            if (!err) {
                if (data.currentTime) {
                    window.currentTime = data.currentTime
                }
                if (data && data.status === '200') {
                    resolve(data.rt) //请求成功
                } else {
                    reject(data.msg)
                }
            } else {
                reject(err) //失败
            }
        })
    })
}
